export const validateEmailSettings = (settings) => {
  const errors = {};
  console.log('Validating settings:', JSON.stringify(settings, null, 2));

  // Validate notification preferences
  if (!settings.notifications) {
    console.log('Missing notifications object');
    errors.notifications = 'Notification preferences are required';
  } else {
    const requiredNotifications = ['bookingConfirmation', 'appointmentReminders', 'schedulingUpdates'];
    requiredNotifications.forEach(key => {
      if (typeof settings.notifications[key] !== 'boolean') {
        console.log(`Invalid notification setting for ${key}:`, settings.notifications[key]);
        if (!errors.notifications) errors.notifications = {};
        errors.notifications[key] = `${key} setting must be a boolean`;
      }
    });
  }

  // Validate templates
  if (!settings.templates) {
    console.log('Missing templates object');
    errors.templates = 'Email templates are required';
  } else {
    ['bookingConfirmation', 'appointmentReminder'].forEach(templateKey => {
      const template = settings.templates[templateKey];
      console.log(`Checking template ${templateKey}:`, template);
      if (!template) {
        if (!errors.templates) errors.templates = {};
        errors.templates[templateKey] = `${templateKey} template is required`;
        console.log(`Missing template: ${templateKey}`);
      } else {
        if (!template.subject) {
          console.log(`Missing subject for ${templateKey}`);
          if (!errors.templates) errors.templates = {};
          if (!errors.templates[templateKey]) errors.templates[templateKey] = {};
          errors.templates[templateKey].subject = 'Subject is required';
        }
        if (!template.body) {
          console.log(`Missing body for ${templateKey}`);
          if (!errors.templates) errors.templates = {};
          if (!errors.templates[templateKey]) errors.templates[templateKey] = {};
          errors.templates[templateKey].body = 'Body is required';
        }
      }
    });
  }

  // Validate reminder settings
  if (typeof settings.reminderEnabled !== 'boolean') {
    console.log('Invalid reminderEnabled:', settings.reminderEnabled);
    errors.reminderEnabled = 'Reminder enabled setting must be a boolean';
  }

  if (settings.reminderEnabled) {
    if (!Array.isArray(settings.reminders)) {
      console.log('Reminders must be an array');
      errors.reminders = 'Reminders must be an array';
    } else if (settings.reminders.length === 0) {
      console.log('At least one reminder is required when reminders are enabled');
      errors.reminders = 'At least one reminder is required when reminders are enabled';
    } else if (settings.reminders.length > 3) {
      console.log('Maximum of 3 reminders allowed');
      errors.reminders = 'Maximum of 3 reminders allowed';
    } else {
      const validHours = [24, 48, 72, 96, 120, 144, 168, 192, 216, 240, 264, 288, 312, 336];
      const invalidHours = settings.reminders.filter(hours => !validHours.includes(hours));
      if (invalidHours.length > 0) {
        console.log('Invalid reminder hours:', invalidHours);
        errors.reminders = 'Invalid reminder timing values';
      }
    }
  }

  console.log('Validation errors:', errors);
  return errors;
};

export const validateTestEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}; 